import create from './create'
import registerRenderers from './renderers/register'
import numbro from 'numbro'

const elementMap = new Map();

function hotInitialize() {
    if (typeof $.fn.dataTable !== 'function') return;

    registerRenderers();
    loadNumbroLocales();

    const root = document;
    $(root).find("[data-excel-table]").each((index, element) => {
        const id = element.getAttribute('id');
        if (elementMap.has(id) === false) {
            const instance = create(element);
            elementMap.set(id, { element, instance });
        }
    });
}

function hotFinalize() {
    for (const [key, value] of elementMap) {
        const element = value.element;
        const hotInstance = value.instance;

        hotInstance.destroy();
        element.parentNode.removeChild(element);
    }
    elementMap.clear();
}

function loadNumbroLocales() {
    numbro.loadCulturesInNode();
}

export default {
    hotInitialize,
    hotFinalize
};





// WEBPACK FOOTER //
// ./App/components/Handsontable/Handsontable.js